import {
  FetchFinProductCategoriesFilters,
  FetchProductCategoriesCacheKey
} from '../../productsTypes';

import {
  FETCH_PRODUCT_TYPES_QUERY,
  FetchProductTypesQueryResponse
} from '../../queries/fetchProductTypes.query';
import { FETCH_CACHE_PRODUCT_TYPES_QUERY } from '../../queries/fetchCacheProductTypes.query';

import { useFinPaginatedCategories } from '../../../categories/hooks/useFinPaginatedCategories';

import { FetchCategoriesScopes } from '../../../categories/categoriesTypes';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const defaultInitialFilters = {
  scope: { eq: FetchCategoriesScopes.PRODUCTS_TYPE }
};
const options = {
  staleTime: 1000 * 60 * 60
};

interface ProductTypesDefaultOptions {
  cacheKey: FetchProductCategoriesCacheKey;
  addInitialFilters?: FetchFinProductCategoriesFilters;
}

function useProductTypes({
  cacheKey,
  addInitialFilters
}: ProductTypesDefaultOptions) {
  const initialFilters = addInitialFilters
    ? { ...defaultInitialFilters, ...addInitialFilters }
    : defaultInitialFilters;

  const {
    categories,
    categoriesError,
    categoriesFetched,
    categoriesIsPlaceholderData
  } = useFinPaginatedCategories<FetchProductTypesQueryResponse>({
    action: CategoriesPermissions.READ_PRODUCT_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    query: FETCH_PRODUCT_TYPES_QUERY,
    cacheQuery: FETCH_CACHE_PRODUCT_TYPES_QUERY,
    initialFilters,
    options
  });

  return {
    productTypes: categories,
    productTypesErrorMessage: categoriesError,
    productTypesFetched: categoriesFetched,
    productTypesIsPlaceholderData: categoriesIsPlaceholderData
  };
}

export default useProductTypes;
